import {Video} from '../types/video';
import {isVideoPlayable} from './isVideoPlayable';

// Returns the number of preceding playable videos in the list of video assets
export const getPrecedingPlayableVideos = (videoAssets: Video[], index: number) =>
  videoAssets.slice(0, index).filter(isVideoPlayable).length;
